import logo from './logo.svg';
import './App.css';
import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useLocation
} from "react-router-dom";
import store from './redux/store';

import { getUser } from './redux/action';
import { Provider, useDispatch, useSelector } from 'react-redux';
import Header from './Path/Header';
import NotFound from './Path/NotFound';
import SideBar from './Path/SideBar';

import AllBooks from './Path/Admin/Book';
import NewBook from './Path/Admin/Book/BookAddNew';
import BookDetails from './Path/Admin/Book/BookDetails';
import { slugs } from './Constant/slugs';
import AllExam from './Path/Admin/Exam';
import AllResults from './Path/Admin/Results';
import DemoExamDetails from './Path/Admin/DemoExam/DemoExamDetails';
import ExamDetails from './Path/Admin/Exam/ExamDetails';
import ResultDetails from './Path/Admin/Results/ResultsDetails';
import NewDemoExam from './Path/Admin/DemoExam/DemoExamAddNew';
import NewExam from './Path/Admin/Exam/ExamAddNew';
import AllStudents from './Path/Admin/Students';
import StudentDetails from './Path/Admin/Students/StudentDetails';
import NewStudent from './Path/Admin/Students/StudentAddNew';
import AllDemoExamList from './Path/Student/DemoExam';
import LoginScreen from './Path/SignIn';
import StartDemoExam from './Path/Student/StartDemoExam';
import ExamResult from './Path/Student/ExamResult';
import ExamAllResult from './Path/Student/AllResults';
import Profile from './Path/Profile';
import ExamResultDetailsAdmin from './Path/Admin/Results/ResultsDetails';
import HomeScreenLogin from './Path/Login/HomeScreen';
import ClassRoom from './Path/Login/ClassRoom';
import StartClassExam from './Path/Login/ClassRoom/ClassExam';
import AllMyExamList from './Path/Student/Exam';
import StartMyExam from './Path/Student/StartExam';
import AllBatch from './Path/Admin/Batch';
import AllChapter from './Path/Admin/Chapter';
import BatchDetails from './Path/Admin/Batch/BatchDetails';
import ChapterDetails from './Path/Admin/Chapter/ChapterDetails';
import NewBatch from './Path/Admin/Batch/BatchAddNew';
import NewChapter from './Path/Admin/Chapter/ChapterAddNew';
import ImageUploadMain from './Path/Admin/Images';
import AllWeeklyExamAdmin from './Path/Admin/WeeklyExam';
import WeeklyExamDetails from './Path/Admin/WeeklyExam/WeeklyExamDetails';
import NewWeeklyExam from './Path/Admin/WeeklyExam/WeeklyExamAddNew';
import AllPackages from './Path/Admin/BatchExamPackages';
import NewPackages from './Path/Admin/BatchExamPackages/PackagesAddNew';
import PackagesDetails from './Path/Admin/BatchExamPackages/PackagesDetails';
import AllBatchOrders from './Path/Admin/BatchOrders';
import NewBatchOrder from './Path/Admin/BatchOrders/BatchOrderNew';
import BatchOrdersDetails from './Path/Admin/BatchOrders/BatchOrderDetails';
import AllWeeklyExamList from './Path/Student/Exam/weeklyExam';
import StartWeeklyExam from './Path/Student/StartWeeklyExam';
import AllDailyExamList from './Path/Student/DailyExam';
import StartDailyExam from './Path/Student/StartDailyExam';
import BatchPayment from './Path/Student/DailyExam/BatchPayment';
import BatchExam from './Path/Student/DailyExam/BatchDetails';
import AllCourse from './Path/Student/Course';
import StartCourse from './Path/Student/Course/StartCourse';
import AllResultsPackage from './Path/Admin/ResultsPackage';
import PackageExamResultDetailsAdmin from './Path/Admin/ResultsPackage/ResultsDetails';
import CoursePayment from './Path/Student/Course/CoursePayment';
import AllCourseOrders from './Path/Admin/CourseOrders';
import CourseOrdersDetails from './Path/Admin/CourseOrders/CourseOrderDetails';
import NewCourseOrder from './Path/Admin/CourseOrders/CourseOrderNew';
import AllBooksView from './Path/Student/Books';
import AllBooksDetails from './Path/Student/Books/BookDetails';
import ColorVisionAdmin from './Path/Admin/ColorVision';
import PDFView from './Path/Student/Books/PDFViewer';
import YoutubeView from './Path/Student/Course/VideoViewer';
import AllTab from './Path/Admin/Tab';
import TabDetails from './Path/Admin/Tab/TabDetails';
import NewTab from './Path/Admin/Tab/TabAddNew';
import HomeScreenLoginTab from './Path/Tab';
import StartTabExam from './Path/Tab/ClassExam';
import AllPhysicalStudents from './Path/Admin/PhysicalStudents';
import PhysicalStudentDetails from './Path/Admin/PhysicalStudents/PhysicalStudentDetails';
import NewPhysicalStudent from './Path/Admin/PhysicalStudents/PhysicalStudentAddNew';
import AllTeacherList from './Path/Admin/Teacherlists';
import TeacherListDetails from './Path/Admin/Teacherlists/TeacherDetails';
import NewTeacherList from './Path/Admin/Teacherlists/TeacherListAddNew';
import NewTest from './Path/Admin/Test/TeacherAddNew';
import AllTest from './Path/Admin/Test';
import TestDetails from './Path/Admin/Test/TeacherDetails';
import PhysicalLoginScreen from './Path/PhysicalSignIn';
import AllExamCategory from './Path/Admin/ExamCategories';
import NewExamCategory from './Path/Admin/ExamCategories/ExamCategoryAddNew';
import ExamCategoryDetails from './Path/Admin/ExamCategories/ExamCategoryDetails';
import AllGeneralForm from './Path/Admin/GeneralForm';
import AllRegistrationForm from './Path/Admin/RegistrationForm';
import AllOnlineStudents from './Path/Admin/OnlineStudents';
import OnlineStudentDetails from './Path/Admin/OnlineStudents/OnlineStudentDetails';
import NewOnlineStudent from './Path/Admin/OnlineStudents/OnlineStudentAddNew';
import HomeScreenBeforeLogin from './Path/Login/HomeScreen/HomeBeforeLogin';
import OnlineLoginScreen from './Path/OnlineSignIn';


export default class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <AppMain />
        </Router>
      </Provider>
    );
  }
}

function AppMain() {
  const [loginState, setLoginState] = React.useState(true)
  const dispatch = useDispatch()
  const myState = useSelector((state) => state.LocationState);
  const Login = useSelector((state) => state.LoginState);
  const location = useLocation()

  const [menuExpand, setMenuExpand] = React.useState(false)
  useEffect(() => {
    dispatch(getUser())
    setLoginState(Login.isLoading)
  }, [])
  return (
    <div className="overflow-x-hidden" >
      {Login.token == null ?
        <>
          {/* <Header setMenuExpand={setMenuExpand} menuExpand={menuExpand} /> */}
          <Switch>
            <Route exact path="/"><HomeScreenBeforeLogin /></Route>
            <Route exact path="/login"><LoginScreen /></Route>
            <Route exact path="/physical-student-login"><PhysicalLoginScreen /></Route>
            <Route exact path="/online-student-login"><OnlineLoginScreen /></Route>
            <Route exact path={slugs.demo_exam}><AllDemoExamList /></Route>
            <Route exact path={`${slugs.start_demo_exam}/:id`}><StartDemoExam /></Route>
            <Route exact path={slugs.classroom}><ClassRoom /></Route>
            <Route exact path={`${slugs.start_class_exam}/:id`}><StartClassExam /></Route>
            <Route path="*"><LoginScreen /></Route>
          </Switch>
        </>
        :
        <div className="row" >
          {/* {!location.pathname.includes("start") && */}
          {(Login.userRole == "author" || Login.userRole == "teacher") &&
            <div className="sidebar-width-expand" style={{ borderRight: "3px solid #e4e4e4" }} >
              <div className={"sidebar-design"}>
                <div style={{ backgroundColor: "#fff" }} >
                  <SideBar menuExpand={menuExpand} />
                </div>
              </div>
            </div>
          }

          {/* {(Login.userRole == "author" || Login.userRole == "teacher") &&
            <div className="sidebar-small-screen ">
              <div className={"sidebar-design"} >
                <SideBar setMenuExpand={setMenuExpand} />
              </div>
            </div>
          } */}

          <div className={
            // !location.pathname.includes("start") ? "main-width-expand" : "main-width-full"} 
            (Login.userRole == "author" || Login.userRole == "teacher") ?
              "main-width-expand" : "main-width-full"
          }
            style={{ backgroundColor: "#f3f3f3", minHeight: "100vh" }}>
            {!location.pathname.includes("start") &&
              <Header setMenuExpand={setMenuExpand} menuExpand={menuExpand} />
            }
            <div style={{}}>
              {(Login.userRole == "author" || Login.userRole == "teacher") &&
                <Switch>

                  <Route exact path="/"><HomeScreenLogin /></Route>
                  <Route path="/admin-dash"><HomeScreenLogin /></Route>

                  <Route exact path="/profile"><Profile /></Route>
                  <Route path={slugs.all_books}><AllBooks /></Route>
                  <Route path={`${slugs.all_exam}/:id`}><AllExam /></Route>
                  <Route path={slugs.all_results}><AllResults /></Route>
                  <Route path={slugs.all_daily_results}><AllResultsPackage /></Route>
                  <Route path={`/general-form`}><AllGeneralForm /></Route>
                  <Route path={`/registration-form`}><AllRegistrationForm /></Route>

                  <Route path={slugs.all_students}><AllStudents /></Route>
                  <Route path={slugs.all_tests}><AllTest /></Route>
                  <Route path={slugs.all_batch}><AllBatch /></Route>
                  <Route path={slugs.all_chapter}><AllChapter /></Route>
                  <Route path={"/Images"}><ImageUploadMain /></Route>
                  <Route path={"/color-vision-admin"}><ColorVisionAdmin /></Route>

                  <Route path={slugs.all_exam_packages}><AllPackages /></Route>
                  <Route path={`${slugs.exam_packages_details}:slug`}><PackagesDetails /></Route>
                  <Route path={slugs.new_exam_package}><NewPackages /></Route>

                  <Route path={slugs.all_teacher_list}><AllTeacherList /></Route>
                  <Route path={`${slugs.teacher_list_details}:slug`}><TeacherListDetails /></Route>
                  <Route path={slugs.new_teacher_list}><NewTeacherList /></Route>

                  <Route path={slugs.all_physical_students}><AllPhysicalStudents /></Route>
                  <Route path={`${slugs.physical_student_details}:slug`}><PhysicalStudentDetails /></Route>
                  <Route path={slugs.new_physical_student}><NewPhysicalStudent /></Route>

                  <Route path={slugs.all_online_students}><AllOnlineStudents /></Route>
                  <Route path={`${slugs.online_student_details}:slug`}><OnlineStudentDetails /></Route>
                  <Route path={slugs.new_online_student}><NewOnlineStudent /></Route>


                  <Route path={slugs.all_exam_category}><AllExamCategory /></Route>
                  <Route path={`${slugs.exam_category_details}:slug`}><ExamCategoryDetails /></Route>
                  <Route path={slugs.new_exam_category}><NewExamCategory /></Route>


                  <Route path={slugs.all_batch_orders}><AllBatchOrders /></Route>
                  <Route path={`${slugs.batch_order_details}:slug`}><BatchOrdersDetails /></Route>
                  <Route path={slugs.new_batch_order}><NewBatchOrder /></Route>

                  <Route path={slugs.all_course_orders}><AllCourseOrders /></Route>
                  <Route path={`${slugs.course_order_details}:slug`}><CourseOrdersDetails /></Route>
                  <Route path={slugs.new_course_order}><NewCourseOrder /></Route>

                  <Route path={slugs.all_course_packages}><AllChapter /></Route>
                  <Route path={`${slugs.course_packages_details}:slug`}><ChapterDetails /></Route>
                  <Route path={slugs.new_course_package}><NewChapter /></Route>

                  <Route path={slugs.all_tab}><AllTab /></Route>
                  <Route path={`${slugs.tab_details}:slug`}><TabDetails /></Route>
                  <Route path={slugs.new_tab}><NewTab /></Route>

                  <Route path={`${slugs.books_details}:slug`}><BookDetails /></Route>
                  <Route path={`${slugs.demo_exam_details}:slug`}><DemoExamDetails /></Route>
                  <Route path={`${slugs.exam_details}:slug`}><ExamDetails /></Route>
                  <Route path={`${slugs.daily_result_admin_view}:slug`}><PackageExamResultDetailsAdmin /></Route>
                  <Route path={`${slugs.result_details}:slug`}><ResultDetails /></Route>
                  <Route path={`${slugs.student_details}:slug`}><StudentDetails /></Route>
                  <Route path={`${slugs.test_details}:slug`}><TestDetails /></Route>
                  <Route path={`${slugs.batch_details}:slug`}><BatchDetails /></Route>
                  <Route path={`${slugs.chapter_details}:slug`}><ChapterDetails /></Route>

                  <Route path={slugs.new_book}><NewBook /></Route>
                  <Route path={slugs.new_demo_exam}><NewDemoExam /></Route>
                  <Route path={`${slugs.new_exam}/:id`}><NewExam /></Route>
                  <Route path={slugs.new_student}><NewStudent /></Route>
                  <Route path={slugs.new_test}><NewTest /></Route>
                  <Route path={slugs.new_batch}><NewBatch /></Route>
                  <Route path={slugs.new_chapter}><NewChapter /></Route>

                  <Route path={`${slugs.all_exam_2}/:id`}><AllWeeklyExamAdmin /></Route>
                  <Route path={`${slugs.exam_2_details}:slug`}><WeeklyExamDetails /></Route>
                  <Route path={`${slugs.new_exam_2}/:id`}><NewWeeklyExam /></Route>

                  <Route path={`${slugs.exam}`}><AllMyExamList /></Route>
                  <Route path={`${slugs.weekly_exam}`}><AllWeeklyExamList /></Route>
                  <Route path={slugs.demo_exam}><AllDemoExamList /></Route>

                  <Route path={`${slugs.start_exam}/:slug`}><StartMyExam /></Route>
                  <Route path={`${slugs.start_weekly_exam}/:slug`}><StartWeeklyExam /></Route>
                  <Route path={`${slugs.start_demo_exam}/:slug`}><StartDemoExam /></Route>
                  <Route path={slugs.course}><AllCourse /></Route>
                  <Route path={slugs.start_course}><StartCourse /></Route>

                  <Route path={`${slugs.result_admin_view}/:slug`}><ExamResultDetailsAdmin /></Route>
                  <Route path={slugs.daily_exam_result}><ExamResult /></Route>

                  <Route path={slugs.exam_result_list}><ExamAllResult /></Route>
                  <Route exact path={slugs.classroom}><ClassRoom /></Route>
                  <Route exact path={`${slugs.start_class_exam}/:id`}><StartClassExam /></Route>

                  <Route path={slugs.daily_exam}><AllDailyExamList /></Route>
                  <Route path={`${slugs.start_daily_exam}/:slug`}><StartDailyExam /></Route>
                  <Route path={`${slugs.batch_exam}/:id`}><BatchExam /></Route>
                  <Route path={`${slugs.batch_payment}/:id`}><BatchPayment /></Route>
                  <Route path={`${slugs.course_payment}/:id`}><CoursePayment /></Route>
                  <Route path={`/start-pdf/:slug`}><PDFView /></Route>

                  <Route exact path={`${slugs.books}`}><AllBooksView /></Route>
                  <Route exact path={`${slugs.book_details_student}/:id`}><AllBooksDetails /></Route>
                  <Route path={"/start-video/:id"}><YoutubeView /></Route>

                  <Route path="*"><NotFound /></Route>
                </Switch>
              }

              {(Login.userRole == "student" || Login.userRole == "subscriber" || Login.userRole == "physical_student") &&
                <Switch>
                  <Route exact path="/"><HomeScreenLogin /></Route>
                  <Route exact path="/profile"><Profile /></Route>

                  <Route path={`${slugs.exam}`}><AllMyExamList /></Route>
                  <Route path={`${slugs.weekly_exam}`}><AllWeeklyExamList /></Route>
                  <Route path={slugs.demo_exam}><AllDemoExamList /></Route>
                  <Route path={slugs.course}><AllCourse /></Route>
                  <Route path={slugs.start_course}><StartCourse /></Route>
                  <Route path={`/start-pdf/:slug`}><PDFView /></Route>

                  <Route path={`${slugs.start_exam}/:slug`}><StartMyExam /></Route>
                  <Route path={`${slugs.start_weekly_exam}/:slug`}><StartWeeklyExam /></Route>
                  <Route path={`${slugs.start_demo_exam}/:slug`}><StartDemoExam /></Route>

                  <Route path={`${slugs.result_admin_view}/:slug`}><ExamResultDetailsAdmin /></Route>
                  <Route path={slugs.exam_result}><ExamResult /></Route>

                  <Route path={slugs.exam_result_list}><ExamAllResult /></Route>
                  <Route exact path={slugs.classroom}><ClassRoom /></Route>
                  <Route exact path={`${slugs.start_class_exam}/:id`}><StartClassExam /></Route>

                  <Route path={`${slugs.start_daily_exam}/:slug`}><StartDailyExam /></Route>
                  <Route path={slugs.daily_exam}><AllDailyExamList /></Route>
                  <Route path={`${slugs.batch_exam}/:id`}><BatchExam /></Route>
                  <Route path={`${slugs.batch_payment}/:id`}><BatchPayment /></Route>
                  <Route path={`${slugs.course_payment}/:id`}><CoursePayment /></Route>

                  <Route exact path={`${slugs.books}`}><AllBooksView /></Route>
                  <Route exact path={`${slugs.book_details_student}/:id`}><AllBooksDetails /></Route>
                  <Route path={"/start-video/:id"}><YoutubeView /></Route>

                  <Route path="*"><NotFound /></Route>
                </Switch>
              }

              {(Login.userRole == "tab") &&
                <Switch>
                  <Route exact path="/"><HomeScreenLoginTab /></Route>
                  <Route exact path="/profile"><Profile /></Route>

                  <Route path={`${slugs.exam}`}><AllMyExamList /></Route>
                  <Route path={`/tabexam`}><StartTabExam /></Route>
                  <Route path={`${slugs.weekly_exam}`}><AllWeeklyExamList /></Route>
                  <Route path={slugs.demo_exam}><AllDemoExamList /></Route>
                  <Route path={slugs.course}><AllCourse /></Route>
                  <Route path={slugs.start_course}><StartCourse /></Route>
                  <Route path={`/start-pdf/:slug`}><PDFView /></Route>

                  <Route path={`${slugs.start_exam}/:slug`}><StartMyExam /></Route>
                  <Route path={`${slugs.start_weekly_exam}/:slug`}><StartWeeklyExam /></Route>
                  <Route path={`${slugs.start_demo_exam}/:slug`}><StartDemoExam /></Route>

                  <Route path={`${slugs.result_admin_view}/:slug`}><ExamResultDetailsAdmin /></Route>
                  <Route path={slugs.exam_result}><ExamResult /></Route>

                  <Route path={slugs.exam_result_list}><ExamAllResult /></Route>
                  <Route exact path={slugs.classroom}><ClassRoom /></Route>
                  <Route exact path={`${slugs.start_class_exam}/:id`}><StartClassExam /></Route>

                  <Route path={`${slugs.start_daily_exam}/:slug`}><StartDailyExam /></Route>
                  <Route path={slugs.daily_exam}><AllDailyExamList /></Route>
                  <Route path={`${slugs.batch_exam}/:id`}><BatchExam /></Route>
                  <Route path={`${slugs.batch_payment}/:id`}><BatchPayment /></Route>
                  <Route path={`${slugs.course_payment}/:id`}><CoursePayment /></Route>

                  <Route exact path={`${slugs.books}`}><AllBooksView /></Route>
                  <Route exact path={`${slugs.book_details_student}/:id`}><AllBooksDetails /></Route>
                  <Route path={"/start-video/:id"}><YoutubeView /></Route>

                  <Route path="*"><NotFound /></Route>
                </Switch>
              }
            </div>
          </div>
        </div>
      }

    </div >
  )
}
